var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.17437
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff6d5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff6d5",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff6d5",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff0",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff0",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 370.71,
    x2: 422.86,
    y1: 584.51,
    y2: 704.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a05a2c",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a05a2c",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 377.86,
    x2: 353.57,
    y1: 743.08,
    y2: 740.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d4aa00",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff6d5",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 370,
    x2: 340,
    y1: 685.22,
    y2: 715.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b79024",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b79024",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 482.86,
    x2: 519.29,
    y1: 768.79,
    y2: 852.36,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "repeat"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff6d5",
    stopOpacity: 0.18803,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff6d5",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 147.14,
    x2: 144.29,
    y1: 715.58,
    y2: 870.22,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "repeat"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff6d5",
    stopOpacity: 0.42308,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff6d5",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 317.14,
    x2: 357.5,
    y1: 771.29,
    y2: 679.86,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dfc33c",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#776614",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 313.57,
    x2: 339.29,
    y1: 750.22,
    y2: 750.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd01b",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#504416",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 529.29,
    x2: 457.14,
    y1: 765.22,
    y2: 650.22,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 475.71,
    x2: 443.57,
    y1: 826.65,
    y2: 571.65,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 295,
    x2: 460,
    y1: 689.51,
    y2: 638.79,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 468.57,
    x2: 370,
    y1: 601.65,
    y2: 834.51,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 485,
    x2: 407.86,
    y1: 780.22,
    y2: 675.93,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 591.43,
    x2: 489.29,
    y1: 566.65,
    y2: 717.36,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 420,
    x2: 427.14,
    y1: 604.51,
    y2: 755.22,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 410,
    x2: 394.29,
    y1: 600.22,
    y2: 665.93,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 111.43,
    x2: 235.71,
    y1: 794.51,
    y2: 668.08,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 334.29,
    x2: 345.71,
    y1: 626.65,
    y2: 750.22,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x2: 0,
    y1: 670.93,
    y2: 776.65,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -12.857,
    x2: 344.29,
    y1: 895.22,
    y2: 705.22,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 355.01,
    cy: 725.69,
    r: 24.786,
    gradientTransform: "matrix(1.1152 0 0 5.8747 -44.484 -3477.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4eed7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4eed7",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 340.42,
    cy: 697.8,
    r: 43.437,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 349.29,
    cy: 798.01,
    r: 174.04,
    gradientTransform: "matrix(.88919 -.19289 .039777 .18336 6.9615 598.45)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-167.14 -419.04)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m170 552.36 138.57 60s18.571 11.429 50-4.2857 204.29-108.57 204.29-108.57 12.857-5.7143-25.714-5.7143c-100 0-288.57 31.429-298.57 31.429s-58.571 22.857-58.571 22.857-8.5714-2.8572-10 4.2857z",
    fill: "#5f5705",
    fillRule: "evenodd",
    filter: "url(#aa)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.285 -180.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m222.14 632.96 217.86-32.096 111.67 10.141-203.94 48.634-125.59-26.678z",
    fill: "#c0a421",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.5 633.08-12.857 12.857 127.5 32.143 8.5714-19.643-123.21-25.357z",
    fill: "#c0a421",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.06 678.08c0-5.7143 7.6479-18.737 7.6479-18.737l7.1428-1.1835 10.339 19.921h-25.13z",
    fill: "#fff6d5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361.43 678.08 196.62-58.413-6.6229-8.7299-200 47.143 10 20z",
    fill: "#c0a421",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210 645.93-24.286 81.429 1.4286 5.7143 134.29 52.143 16.071-107.14-127.5-32.143z",
    fill: "#c0a421",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210 645.93-24.286 81.429 1.4286 5.7143 134.29 52.143 16.071-107.14-127.5-32.143z",
    fill: "url(#m)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.5 677.36-16.071 107.5s31.429 4.6429 48.571-3.9286c-1.4286-22.857-9.2857-103.21-9.2857-103.21l-23.214-0.35715z",
    fill: "#c0a421",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m370 780.93 201.43-103.57-13.214-58.005-197.5 58.005 9.2857 103.57z",
    fill: "#c0a421",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m370 780.93 201.43-103.57-13.214-58.005-197.5 58.005 9.2857 103.57z",
    fill: "url(#z)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361.43 678.08 196.62-58.413-6.6229-8.7299-200 47.143 10 20z",
    fill: "url(#y)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m370 780.93 201.43-103.57-13.214-58.005-197.5 58.005 9.2857 103.57z",
    fill: "url(#x)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361.43 678.08 196.62-58.413-6.6229-8.7299-200 47.143 10 20z",
    fill: "url(#w)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.14 632.96 217.86-32.096 111.67 10.141-203.94 48.634-125.59-26.678z",
    fill: "url(#v)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m370 780.93 201.43-103.57-13.214-58.005-197.5 58.005 9.2857 103.57z",
    fill: "url(#u)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361.43 678.08 196.62-58.413-6.6229-8.7299-200 47.143 10 20z",
    fill: "url(#e)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.5 677.36-16.071 107.5s31.429 4.6429 48.571-3.9286c-1.4286-22.857-9.2857-103.21-9.2857-103.21l-23.214-0.35715z",
    fill: "url(#h)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.5 677.36-16.071 107.5s31.429 4.6429 48.571-3.9286c-1.4286-22.857-9.2857-103.21-9.2857-103.21l-23.214-0.35715z",
    fill: "url(#t)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.5 677.36-16.071 107.5s31.429 4.6429 48.571-3.9286c-1.4286-22.857-9.2857-103.21-9.2857-103.21l-23.214-0.35715z",
    fill: "url(#s)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383.84 670.59-23.125 6.7812 9.2812 103.56 141.25-72.625c-51.367-4.82-96.197-18.535-127.41-37.719z",
    fill: "url(#r)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361.43 678.08 128.05-38.413-48.766-2.3013-89.286 20.714 10 20z",
    fill: "url(#e)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m309.66 621.66c-3.9465 0-7.8497 0.06417-11.719 0.15625l-75.781 11.156 125.59 26.656 81.656-19.469c-26.963-11.214-70.552-18.5-119.75-18.5z",
    fill: "url(#q)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210 645.93-24.286 81.429 1.4286 5.7143 134.29 52.143 16.071-107.14-127.5-32.143z",
    fill: "url(#p)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.5 633.08-12.857 12.857 127.5 32.143 8.5714-19.643-123.21-25.357z",
    fill: "url(#o)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m370 780.93 201.43-103.57-13.214-58.005-197.5 58.005 9.2857 103.57z",
    fill: "url(#n)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210 645.93-24.286 81.429 1.4286 5.7143 134.29 52.143 16.071-107.14-127.5-32.143z",
    fill: "url(#l)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.5 677.36-16.071 107.5s31.429 4.6429 48.571-3.9286c-1.4286-22.857-9.2857-103.21-9.2857-103.21l-23.214-0.35715z",
    fill: "url(#k)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.33289 .35912 -.66048 .69147 689.49 66.274)",
    d: "m383.86 697.8a43.437 43.437 0 1 1 -86.873 0 43.437 43.437 0 1 1 86.873 0z",
    fill: "url(#c)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.29262 .39263 -.80001 -.52377 999.8 902.86)",
    d: "m383.86 697.8a43.437 43.437 0 1 1 -86.873 0 43.437 43.437 0 1 1 86.873 0z",
    fill: "url(#c)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m557.14 618.79-195.71 60s-12.857 2.8572-21.429 0.71429-127.14-32.143-127.14-32.143",
    fill: "none",
    stroke: "url(#g)",
    strokeWidth: 3.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m342.14 681.65s12.857 0 16.429-0.71429-5 104.29-5 104.29h-7.8571s-1.4286-97.143-3.5714-103.57z",
    fill: "url(#j)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m215.71 742.36 128.57-28.571v-30l-48.571-15.714-100 68.571 20 5.7143z",
    fill: "url(#i)",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.215040fb6a6114d4a44f3f6c647ede77.svg";
export { ForwardRef as ReactComponent };